export default __webpack_public_path__ + "static/media/MarsCentra-Book.6a9df67b.woff";